/* RSI v2 · Med reisen – logikk fra Main.dc.html (Claude Design). Krever rsi-dc.js. */

class RSIMedReisenBase extends DCLogic {
  get D() {
    if (this._D) return this._D;
    const Q = {
      'OSL-DOH': [[236.5,92],[307.5,226],[351.7,366.3]], 'DOH-DPS': [[351.7,366.3],[545.1,483.5],[809.9,500]],
      'OSL-DXB': [[236.5,92],[319.8,225.7],[373.1,368.1]], 'DXB-DPS': [[373.1,368.1],[558,480.1],[809.9,500]],
      'OSL-IST': [[236.5,92],[251.3,165],[256.4,237.4]], 'IST-DPS': [[256.4,237.4],[492.4,402.3],[809.9,500]],
      'OSL-AMS': [[236.5,92],[212.6,109.1],[190.1,127.4]], 'AMS-SIN': [[190.1,127.4],[455.9,277.5],[705.2,473.4]],
      'SIN-DPS': [[705.2,473.4],[754.9,490.5],[809.9,500]], 'OSL-BKK': [[236.5,92],[481,214.7],[654.6,403.7]],
      'BKK-DPS': [[654.6,403.7],[725.2,458.4],[809.9,500]]
    };
    const g = (k) => Q[k];
    const routes = [
      { air: 'Qatar Airways', c: '#0C7A88', codes: ['OSL','DOH','DPS'], l: [390,190,590], a: [g('OSL-DOH')], b: [g('DOH-DPS')] },
      { air: 'Emirates', c: '#2f5d7c', codes: ['OSL','DXB','DPS'], l: [410,240,550], a: [g('OSL-DXB')], b: [g('DXB-DPS')] },
      { air: 'Turkish Airlines', c: '#a14a3a', codes: ['OSL','IST','DPS'], l: [235,110,770], a: [g('OSL-IST')], b: [g('IST-DPS')] },
      { air: 'KLM', c: '#C89A3C', codes: ['OSL','AMS','SIN','DPS'], l: [110,115,995], a: [g('OSL-AMS')], b: [g('AMS-SIN'), g('SIN-DPS')] },
      { air: 'Thai Airways', c: '#6b5d3f', codes: ['OSL','BKK','DPS'], l: [690,200,260], a: [g('OSL-BKK')], b: [g('BKK-DPS')] }
    ];
    const CITY = { DOH: 'Doha', DXB: 'Dubai', IST: 'Istanbul', AMS: 'Amsterdam', BKK: 'Bangkok', SIN: 'Singapore' };
    routes.forEach((r) => {
      r.total = r.l[0] + r.l[1] + r.l[2];
      r.seq = [{ f: 1, m: r.l[0] }, { m: r.l[1] }, { f: 1, m: r.l[2] }];
      r.via = 'Bytte i ' + CITY[r.codes[1]] + ' · ' + this.fmt(r.l[1]);
      if (r.codes.length === 4) {
        // KL835 AMS–SIN–DPS: 12 t 40 min fly, 1 t 20 min mellomlanding i Singapore, 2 t 35 min fly (= 995 min)
        r.seq = [{ f: 1, m: r.l[0] }, { m: r.l[1] }, { f: 1, m: 760 }, { m: 80 }, { f: 1, m: 155 }];
        r.via += ' · mellomlanding i Singapore · ' + this.fmt(80);
      }
      // Flyplasskodene plasseres over stripen: OSL i starten, hvert stopp midt over sin lyse del, DPS i enden.
      const tot = r.seq.reduce((a, s) => a + s.m, 0);
      r.marks = [{ code: 'OSL', x: '0%', cls: 'c0' }];
      let cum = 0, hub = 1;
      r.seq.forEach((s) => {
        if (!s.f) r.marks.push({ code: r.codes[hub++], x: ((cum + s.m / 2) / tot * 100).toFixed(2) + '%', cls: 'ch' });
        cum += s.m;
      });
      r.marks.push({ code: 'DPS', x: '100%', cls: 'c1' });
      r.d1 = this.pathD(r.a); r.d2 = this.pathD(r.b);
    });
    routes.sort((x, y) => x.total - y.total);
    const fast = 0;
    const P = { canggu:[328.9,283.4], seminyak:[341,300.4], ubud:[377.7,227.7], uluwatu:[309.8,354.9], jimbaran:[339.9,339.9], nusadua:[365.6,343.5], sanur:[378.1,300], lovina:[285.6,89.9], amed:[531.2,161.4], sidemen:[450.8,213.9], penida:[488.3,314.6], lembongan:[449.6,295.3], gili:[682.8,165.7], batur:[421.9,123.1], dps:[340.6,322.9] };
    const SIDE = { canggu:'sdl', seminyak:'sdl', ubud:'sdr', uluwatu:'sdl', jimbaran:'sdl', nusadua:'sdr', sanur:'sdr', lovina:'sdt', amed:'sdb', gili:'sdt', batur:'sdr', lembongan:'sdr' };
    const SC = { highlights:'ubud', oyhopping:'penida', bryllup:'uluwatu', familie:'canggu', luksus:'uluwatu', rundreise:'ubud', budsjett:'canggu' };
    const kr = (x) => x.replace(/ /g, '\u00a0');
    const PK = {
      highlights: { tab:'Highlights', tag:'Klassiker', ta:'Bali', tb:'Highlights',
        desc:'Det beste av Bali på én reise: strand, kultur i Ubud og Uluwatu til slutt. Laget for deg som er på Bali for første gang.',
        n:9, a:3, price:'22 900 kr', forWho:'Førstegangsreisende, par og venner',
        s:[{k:'canggu',nm:'Seminyak / Canggu',d:'Dag 1–3',t:'Strandhotell, spa og tid til å lande'},{k:'ubud',nm:'Ubud',d:'Dag 4–6',t:'Risterrasser, templer og rafting eller sykkeltur'},{k:'uluwatu',nm:'Uluwatu og sør-Bali',d:'Dag 7–9',t:'Dagstur til Uluwatu, strand og shopping'}],
        legs:['land','land'], inc:['3–4★ hotell','Privat sjåfør mellom alle destinasjoner','2 guidede utflukter','Lokal support'],
        ch:'Velg denne hvis dere er på Bali for første gang og vil se litt av alt, uten å flytte hotell for ofte.' },
      oyhopping: { tab:'Øyhopping', tag:'Øyhopping', ta:'Bali og', tb:'øyhopping',
        desc:'Guidet tur i Ubud, kecak-dans i Uluwatu og bilfrie Gili-øyer. Alle båter og overganger er ordnet.',
        n:10, a:4, price:'27 900 kr', forWho:'Par og venner som vil ha både kultur og hvite strender',
        s:[{k:'ubud',nm:'Ubud',d:'Dag 2–4',t:'Rismarker, templer og kultur'},{k:'uluwatu',nm:'Uluwatu',d:'Dag 5–6',t:'Klipper og solnedgang'},{k:'gili',nm:'Gili-øyene',d:'Dag 7–9',t:'Snorkling og strand på bilfrie øyer'},{k:'nusadua',nm:'Nusa Dua',d:'Dag 10',t:'Siste dag på stranden'}],
        legs:['land','sea','sea'], inc:['Guidet tur i Ubud og Uluwatu','Hurtigbåt til øyene','Privat sjåfør mellom alle destinasjoner','3–4★ boutique med frokost'],
        ch:'Velg denne hvis dere vil ha Bali og et ekte øyparadis på samme reise, uten å ordne båter selv.',
        rv:{q:'Billett til båt og havneavgift var fikset av dem — dette er jeg veldig glad for at jeg ikke trengte å tenke på.', w:'Øyvind', x:'Lombok og Gili-tur · 2026'} },
      bryllup: { tab:'Bryllupsreise', tag:'Bryllupsreise', ta:'Romantisk', tb:'bryllupsreise',
        desc:'Privat villa i Ubud, soloppgang på Mt. Batur og solnedgang over klippene i Uluwatu.',
        n:8, a:3, price:'29 900 kr', forWho:'Nygifte og par som feirer noe stort',
        s:[{k:'ubud',nm:'Ubud',d:'Dag 1–3',t:'Privat villa med infinity pool, spa og romantisk middag'},{k:'batur',nm:'Mt. Batur',d:'Dag 4–6',t:'Soloppgang på vulkanen, privat sightseeing og parmassasje'},{k:'jimbaran',nm:'Uluwatu / Jimbaran',d:'Dag 7–8',t:'Strandresort, solnedgang og privat strandmiddag'}],
        legs:['land','land'], inc:['4–5★ hotell og villa','Privat transport','Mt. Batur soloppgang','Frokost hver dag'],
        ch:'Velg denne hvis dere vil ha ro, villa og privat transport hele veien.',
        rv:{q:'Vi følte oss veldig godt ivaretatt og kan gi en varm anbefaling. Et lite tips: Om man er glad i sjø og utsikt så anbefales å være et par ekstra dager i Uluwatu.', w:'Hans-Petter og Synne', x:'Bryllupsreise · 2026'} },
      familie: { tab:'Familie', tag:'Familie', ta:'Familieferie', tb:'på Bali',
        desc:'Rolig strandstart, korte kjøreturer og opplevelser barna husker. Bali Zoo og sykkeltur er inkludert.',
        n:10, a:3, price:'19 900 kr', forWho:'Barnefamilier med barn i alle aldre',
        s:[{k:'sanur',nm:'Nusa Dua / Sanur',d:'Dag 1–4',t:'Familievennlig strandhotell, basseng og rolig start'},{k:'ubud',nm:'Ubud',d:'Dag 5–7',t:'Sykkeltur gjennom landsbyer og Bali Zoo'},{k:'jimbaran',nm:'Sør-Bali',d:'Dag 8–10',t:'Dagstur til vannfall og tempel, strand'}],
        legs:['land','land'], inc:['Privat sjåfør mellom destinasjonene og på utflukter','Bali Zoo','Sykkeltur','Familiehotell 3–4★'],
        ch:'Velg denne hvis dere vil starte rolig på stranden og ha korte kjøreturer mellom stedene.' },
      luksus: { tab:'Luksus', tag:'Premium', ta:'Luksus', tb:'Bali',
        desc:'Luksusresort i Ubud, strand og fine dining i sør, og dere velger selv hvordan reisen avsluttes.',
        n:9, a:3, price:'44 900 kr', forWho:'Par og deg som vil ha det lille ekstra',
        s:[{k:'ubud',nm:'Ubud',d:'Dag 1–4',t:'Luksusresort, spa og natur'},{k:'seminyak',nm:'Seminyak / Uluwatu',d:'Dag 5–7',t:'Strand, strandklubb og fine dining'},{k:'lembongan',o:1,nm:'Valgfri øy eller villa',d:'Dag 8–9',t:'En øy med båt, eller privat villa på Bali'}],
        legs:['land','opt'], inc:['5★ hotell / privat villa','Privat sjåfør 24/7','Spa og fine dining','Full fleksibilitet'],
        ch:'Velg denne hvis komfort og fleksibilitet betyr mer enn pris.' },
      rundreise: { tab:'14 dager', tag:'Rundreise', ta:'14-dagers', tb:'rundreise',
        desc:'Hele øya på to uker: nord, øst, øyene og sør. Delfinsafari og hurtigbåt er inkludert.',
        n:13, a:5, price:'32 900 kr', forWho:'Dere som har tid og vil se mer enn sør-Bali',
        s:[{k:'ubud',nm:'Ubud',d:'Dag 1–3',t:'Rismarker, templer, sykkeltur og apeskog'},{k:'lovina',nm:'Lovina',d:'Dag 4–5',t:'Delfinsafari ved soloppgang'},{k:'amed',nm:'Amed / Sidemen',d:'Dag 6–7',t:'Svart sandstrand og risterrasser'},{k:'gili',nm:'Nusa / Gili',d:'Dag 8–10',t:'Hurtigbåt, strand og snorkling'},{k:'canggu',nm:'Canggu / Uluwatu',d:'Dag 11–13',t:'Strandklubb og solnedgang'}],
        legs:['land','land','sea','sea'], inc:['Hurtigbåt t/r øy','Delfinsafari','Sykkeltur og apeskog','Lokal guide og support'],
        ch:'Velg denne hvis dere har to uker og vil oppleve nord, øst og øyene, ikke bare stranden i sør.',
        rv:{q:'Vi fikk se utrolig mange delfiner, ha aper på skuldra, hoppe fra fossefall og mye mer.', w:'Joachim og Julia', x:'Lovina flerdagstur · 2026'} },
      budsjett: { tab:'Budsjett', tag:'Budsjettpakke', ta:'Budsjett', tb:'Bali',
        desc:'Alle høydepunktene på Bali til best mulig pris. Smart og enkel — uten å gå på kompromiss.',
        n:9, a:2, price:'17 900 kr', forWho:'Førstegangsreisende og deg som vil oppleve mest mulig for pengene',
        s:[{k:'ubud',nm:'Ubud',d:'Dag 1–4',t:'Ankomst · Rismarker og templer · Apeskog · Lokal mat og kultur'},{k:'seminyak',nm:'Sør-Bali',d:'Dag 5–9',t:'Strand · Kuta, Seminyak eller Canggu · Aktiviteter og fritid · Shopping'}],
        legs:['land'], inc:['3★ hotell','Privat sjåfør mellom alle destinasjoner','Guidet tur i Ubud','Frokost alle hoteller','Lokal support','Norsk kundeservice'],
        ch:'Velg denne hvis dere vil oppleve det viktigste på Bali uten å betale for mer enn dere trenger. Pengene dere sparer på hotellet, kan gå til en dagstur til Nusa Penida.',
        rv:{q:'Fantastisk øy med mye opplevelser. Utrolig gode hoteller med god standard — og det blankeste vannet jeg noen gang har sett!', w:'Øyvind', x:'Lombok og Gili · 2026'} }
    };
    this._D = { NOTES: {"highlights": ["Vi starter ved sjøen, så dere får landet etter flyturen. Solnedgangen på stranden mellom kl. 18 og 19 er dagens høydepunkt.", "Ubud ligger i høylandet, litt kjøligere og grønnere enn kysten. Risterrassene er finest før kl. 09, før de store gruppene kommer.", "Klippene og strendene i sør er en vakker avslutning. Uluwatu-tempelet og kecak-dansen er best ved solnedgang."], "oyhopping": ["Ubud ligger i høylandet, litt kjøligere og grønnere enn kysten. Risterrassene er finest før kl. 09, før de store gruppene kommer.", "Uluwatu har Balis mest dramatiske klipper og strender. Bruk formiddagen på stranden og solnedgangen ved tempelet.", "Gili-øyene er bilfrie, så dere sykler eller går overalt. Snorkle om morgenen når vannet er klarest, og se solnedgangen fra vestsiden.", "Rolig og ren strand nær flyplassen, perfekt for siste natt. Ta morgenbadet før hentingen."], "bryllup": ["Privat villa i jungelen gir ro etter bryllupet. Morgenene med tåke over dalen og kveldene ved bassenget er det par husker best.", "Vi bor nær vulkanen, så turen til toppen starter uten lang kjøring. Soloppgangen rundt kl. 06 er verdt den tidlige vekkingen.", "Strandresort ved klippene og middag på stranden i Jimbaran. Kom tidlig til solnedgangen for de beste plassene."], "familie": ["Rolige strender uten store bølger, korte avstander og familievennlige hoteller. Bad før kl. 11 og etter kl. 15, når sola er mildere.", "Grønt, kjøligere og fullt av opplevelser for barn, med Bali Zoo og sykkeltur i nærheten. Start dagene tidlig, før varmen.", "Strand og basseng nær flyplassen, så de siste dagene blir rolige og hjemreisen enkel."], "luksus": ["Luksusresort i jungelen med utsikt over dalen. Bruk formiddagen til utflukter, når lyset og temperaturen er best, og ettermiddagen til spa.", "Privat strand, fine dining og strandklubber. Kveldene er det som skiller sør fra resten av øya.", "Dere velger avslutningen: privat villa på Bali eller noen dager på en øy. Vi anbefaler ut fra årstid og hva dere har lyst på."], "rundreise": ["Ubud ligger i høylandet, litt kjøligere og grønnere enn kysten. Risterrassene er finest før kl. 09, før de store gruppene kommer.", "Nord-Bali er roligere og mer autentisk. Delfinene sees ved soloppgang, så vi bor nær stranden for å slippe lang kjøring.", "Svart sandstrand, snorkling rett fra land og risterrasser i Sidemen. Morgenlyset over Mt. Agung er det fineste.", "Øytid med hvite strender og klart vann. Snorkle om morgenen, og nyt solnedgangen fra stranden.", "Avslutning med strandliv, kafeer og solnedgang i Uluwatu før hjemreisen."], "budsjett": ["Ubud gir mest kultur for pengene: templer, rismarker og god, rimelig mat. Gå tidlig til apeskogen, før det blir fullt.", "Sør-Bali har mange rimelige hoteller og restauranter. Canggu passer for kaféliv, Seminyak for shopping og Kuta for lavest pris."]}, routes, fast, P, SIDE, SC, PK, kr, order:['highlights','oyhopping','bryllup','familie','luksus','rundreise','budsjett'] };
    return this._D;
  }
  pathD(segs) {
    let d = 'M' + segs[0][0][0] + ' ' + segs[0][0][1];
    segs.forEach((q) => { d += 'Q' + q[1][0] + ' ' + q[1][1] + ' ' + q[2][0] + ' ' + q[2][1]; });
    return d;
  }
  at(segs, t) {
    const len = segs.map((q) => Math.hypot(q[1][0]-q[0][0], q[1][1]-q[0][1]) + Math.hypot(q[2][0]-q[1][0], q[2][1]-q[1][1]));
    const tot = len.reduce((a, b) => a + b, 0);
    let want = t * tot, i = 0;
    while (i < segs.length - 1 && want > len[i]) { want -= len[i]; i++; }
    const u = Math.max(0, Math.min(1, want / len[i])), q = segs[i], w = 1 - u;
    const x = w*w*q[0][0] + 2*w*u*q[1][0] + u*u*q[2][0];
    const y = w*w*q[0][1] + 2*w*u*q[1][1] + u*u*q[2][1];
    const dx = 2*w*(q[1][0]-q[0][0]) + 2*u*(q[2][0]-q[1][0]);
    const dy = 2*w*(q[1][1]-q[0][1]) + 2*u*(q[2][1]-q[1][1]);
    return 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + (Math.atan2(dy, dx) * 180 / Math.PI).toFixed(1) + ') scale(1.25)';
  }
  fmt(m) { m = Math.round(m / 5) * 5; const h = Math.floor(m / 60), mm = m % 60; return h + ' t' + (mm ? ' ' + mm + ' min' : ''); }
  S() {
    return Object.assign({ e: 0, prog: 0, pkg: 'highlights', shown: 'highlights', gen: 0, swap: false, hi: -1, hl: -1, bt: 0, stat: false, started: false, fl: false, flClosed: false }, this.state || {});
  }
  componentDidMount() {
    const root = document;
    this._reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    const tick = () => this.measure();
    this._h = tick;
    window.addEventListener('scroll', tick, true);
    window.addEventListener('resize', tick);
    this._iv = setInterval(tick, 300);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => {
        es.forEach((en) => {
          if (!en.isIntersecting) return;
          en.target.classList.add('in');
          if (en.target.classList.contains('bm')) { this.setState({ started: true }); this.play(); }
          io.unobserve(en.target);
        });
      }, { threshold: 0.15 });
      this._io = io;
      const watch = () => {
        root.querySelectorAll('.rev,#rjSteps,.bm').forEach((el) => { if (!el.__w) { el.__w = 1; io.observe(el); } });
      };
      this._wi = setInterval(watch, 500);
      watch();
    } else {
      root.querySelectorAll('.rev,#rjSteps').forEach((el) => el.classList.add('in'));
      this.setState({ started: true });
      this.play();
    }
    this.measure();
  }
  play() {
    if (this._braf) cancelAnimationFrame(this._braf);
    this._bt0 = performance.now();
    const step = () => {
      const t = (performance.now() - this._bt0) / 1000;
      this.setState({ bt: t });
      this._braf = t < (this._bEnd || 8) ? requestAnimationFrame(step) : 0;
    };
    this._braf = requestAnimationFrame(step);
  }
  componentWillUnmount() {
    if (this._braf) cancelAnimationFrame(this._braf);
    window.removeEventListener('scroll', this._h, true);
    window.removeEventListener('resize', this._h);
    clearInterval(this._iv); clearInterval(this._wi);
    if (this._raf) cancelAnimationFrame(this._raf);
    if (this._io) this._io.disconnect();
  }
  measure() {
    const vh = window.innerHeight || 800, st = this.S();
    const stat = vh > 2000 || this._reduce;
    const sc = document.scrollingElement || document.documentElement;
    const top = window.scrollY || sc.scrollTop || 0;
    const H = sc.scrollHeight - vh;
    const prog = Math.round((H > 0 ? Math.min(1, top / H) : 0) * 500) / 500;
    let e = 1;
    const route = document.getElementById('rjRoute');
    if (!stat && route) {
      const r = route.getBoundingClientRect(), pin = route.querySelector('.pin');
      const run = r.height - (pin ? pin.offsetHeight : 0);
      if (window.innerWidth <= 700) {
        // Mobil: ingen festet scene. Animasjonen følger seksjonen mens den scroller gjennom skjermen.
        e = Math.max(0, Math.min(1, (vh * 0.8 - r.top) / (r.height * 0.75)));
      } else {
        e = run > 0 ? Math.max(0, Math.min(1, ((64 - r.top) / run) * 1.06)) : 1;
      }
    }
    let fl = false;
    const ex = document.getElementById('velg'), cta = document.getElementById('rjCta');
    if (ex && cta && !stat) {
      const started = ex.getBoundingClientRect().top < vh * 0.4;
      const nearCta = cta.getBoundingClientRect().top < vh * 0.75;
      const atBottom = vh + top > sc.scrollHeight - 500;
      fl = started && !nearCta && !atBottom;
    }
    this._tgt = e;
    if (stat !== st.stat || fl !== st.fl) this.setState({ stat, fl, prog, e: stat ? 1 : st.e });
    if (!stat) this.glide();
  }
  glide() {
    if (this._raf) return;
    const step = () => {
      const st = this.S(), tgt = this._tgt == null ? st.e : this._tgt, d = tgt - st.e;
      if (Math.abs(d) < 0.0006) {
        this._raf = 0;
        if (d !== 0) this.setState({ e: tgt });
        return;
      }
      this.setState({ e: st.e + d * 0.075 });
      this._raf = requestAnimationFrame(step);
    };
    this._raf = requestAnimationFrame(step);
  }
  renderVals() {
    
    const D = this.D, st = this.S(), clamp = (v) => Math.max(0, Math.min(1, v));
    const e = st.stat ? 1 : st.e;
    const sm = (x) => x * x * (3 - 2 * x);
    const kz = sm(clamp((e - 0.04) / 0.9));
    const zs = 1.55 - 0.55 * kz, zx = 325 + 175 * kz, zy = 190 + 100 * kz;
    const camTf = 'translate(500 290) scale(' + zs.toFixed(4) + ') translate(' + (-zx).toFixed(2) + ' ' + (-zy).toFixed(2) + ')';
    const t1 = clamp(e / 0.42), tl = clamp((e - 0.42) / 0.13), t2 = clamp((e - 0.55) / 0.42);
    const f3 = (v) => v.toFixed(3);
    const tone = (i) => (st.hi === i ? '#0C7A88' : '#C89A3C');
    // Hver rute er en rekke etapper: fly (f) og tid på bakken (g). Første fly fyller e 0–.42,
    // første bytte .42–.55, og resten (inkl. KLMs mellomlanding i Singapore) deles på .55–.97 etter minutter.
    const prog = (r) => {
      const sq = r.seq, ts = [clamp(e / 0.42), clamp((e - 0.42) / 0.13)];
      const rest = sq.slice(2), tot = rest.reduce((a, s) => a + s.m, 0), x = clamp((e - 0.55) / 0.42) * tot;
      let cum = 0;
      rest.forEach((s) => { ts.push(clamp((x - cum) / s.m)); cum += s.m; });
      return ts;
    };
    const routes = D.routes.map((r, i) => {
      const ts = prog(r), fl = [];
      r.seq.forEach((s, k) => { if (k >= 2 && s.f) fl.push(ts[k]); });
      const len = r.b.map((q) => Math.hypot(q[1][0] - q[0][0], q[1][1] - q[0][1]) + Math.hypot(q[2][0] - q[1][0], q[2][1] - q[1][1]));
      const drawn = len.reduce((a, L, k) => a + L * fl[k], 0) / len.reduce((a, L) => a + L, 0);
      let k = fl.length - 1;
      while (k > 0 && fl[k] <= 0) k--;
      const tf = fl[0] > 0 ? this.at([r.b[k]], fl[k]) : this.at(r.a, ts[0]);
      const a1 = ts[0] > 0 && fl[0] <= 0, a2 = drawn > 0 && fl[fl.length - 1] < 1;
      return {
        q1: (6 - ts[0] * 100).toFixed(2), qo1: a1 ? '1' : '0', q2: (6 - drawn * 100).toFixed(2), qo2: a2 ? '1' : '0',
        c: tone(i), d1: r.d1, d2: r.d2, o1: (100 * (1 - ts[0])).toFixed(2), o2: (100 * (1 - drawn)).toFixed(2),
        tf, po: fl[fl.length - 1] >= 1 ? '0' : '1',
        cls: st.hi >= 0 && st.hi !== i ? 'dim' : ''
      };
    });
    const passes = D.routes.map((r, i) => {
      const ts = prog(r);
      return {
        air: r.air, c: tone(i), codes: r.codes, via: r.via,
        cls: (st.hi >= 0 && st.hi !== i ? 'dim' : '') + (st.hi === i ? ' on' : ''),
        segs: r.seq.map((s, k) => ({ cls: s.f ? 'sg' : 'sg g', flex: s.m + ' 1 0px', t: f3(ts[k]) })),
        marks: r.marks, fly: this.fmt(r.seq.reduce((a, s) => a + (s.f ? s.m : 0), 0)),
        clock: this.fmt(r.seq.reduce((a, s) => a + s.m, 0)),
        pick: () => this.setState({ hi: st.hi === i ? -1 : i })
      };
    });
    const sr = D.routes[st.hi >= 0 ? st.hi : 0], sts = prog(sr);
    const sumM = (pred) => sr.seq.reduce((a, s, k) => a + (pred(s) ? s.m * sts[k] : 0), 0);
    const CN = { DOH: 'Doha', DXB: 'Dubai', IST: 'Istanbul', AMS: 'Amsterdam', BKK: 'Bangkok', SIN: 'Singapore' };
    const sum = {
      label: st.hi >= 0 ? 'Valgt rute' : 'Raskeste rute',
      clock: this.fmt(sr.seq.reduce((a, s) => a + s.m, 0)), fly: this.fmt(sr.seq.reduce((a, s) => a + (s.f ? s.m : 0), 0)), ground: this.fmt(sr.seq.reduce((a, s) => a + (s.f ? 0 : s.m), 0)),
      name: sr.air + ' via ' + sr.codes.slice(1, -1).map((c) => CN[c]).join(' og ')
    };
    const klm = D.routes.find((r) => r.codes.length === 4), kt = prog(klm);
    const mapCls = 'pm' + (e >= 0.42 ? ' m1' : '') + (kt[2] >= 1 ? ' m2' : '') + (kt[3] > 0 && kt[3] < 1 ? ' sinw' : '') + (e >= 0.97 ? ' m3' : '');

    const tabs = D.order.map((k) => ({
      name: D.PK[k].tab, from: D.PK[k].n + ' netter', on: st.pkg === k ? 'true' : 'false',
      pick: () => {
        if (k === this.S().pkg) return;
        this.setState({ pkg: k, gen: this.S().gen + 1, swap: true, hl: -1, bt: 0 });
        if (this.S().started) this.play();
        clearTimeout(this._sw);
        this._sw = setTimeout(() => this.setState({ shown: k, swap: false }), 450);
      }
    }));
    const mp = D.PK[st.pkg], sh = D.PK[st.shown], P = D.P;
    const curve = (a, b, i) => {
      const mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2, dx = b[0] - a[0], dy = b[1] - a[1], len = Math.sqrt(dx * dx + dy * dy) || 1, k = 0.2 * len * (i % 2 ? 1 : -1);
      return 'M' + a[0] + ' ' + a[1] + 'Q' + (mx - dy / len * k).toFixed(1) + ' ' + (my + dx / len * k).toFixed(1) + ' ' + b[0] + ' ' + b[1];
    };
    // Ruten bygges av etapper: bil (land), hurtigbåt (sea) og valgfri båt (opt).
    // Båtetapper går alltid over vann, via et havnepunkt på kysten, og får et båtsymbol.
    const keys = ['dps'].concat(mp.s.map((s) => s.k));
    const ISL = { gili: 1, lembongan: 1, penida: 1 };
    const HB = { e: [477, 235], s: [381, 300] };
    const BC = { 'e-gili': [585, 222], 'amed-gili': [607, 182], 's-lembongan': [414, 290], 's-penida': [430, 318] };
    const segs = [];
    for (let i = 0; i < keys.length - 1; i++) {
      const ka = keys[i], kb = keys[i + 1], a = P[ka], b = P[kb], ty = i === 0 ? 'xfer' : mp.legs[i - 1];
      const boatTy = ty === 'opt' ? 'opt' : 'sea';
      if ((ty === 'sea' || ty === 'opt') && (ISL[ka] || ISL[kb])) {
        const isl = ISL[kb] ? kb : ka, hk = isl === 'gili' ? 'e' : 's';
        if (ka === 'amed' && kb === 'gili') segs.push({ a, b, type: boatTy, c: BC['amed-gili'] });
        else if (ISL[kb]) { segs.push({ a, b: HB[hk], type: 'land' }); segs.push({ a: HB[hk], b, type: boatTy, c: BC[hk + '-' + kb] }); }
        else { const c0 = BC[hk + '-' + ka]; segs.push({ a, b: HB[hk], type: boatTy, c: [c0[0] - 6, c0[1] + 18] }); segs.push({ a: HB[hk], b, type: 'land' }); }
      } else segs.push({ a, b, type: ty });
      segs[segs.length - 1].stop = i;
    }
    // Ruten spilles av i tid (bt, sekunder): en reisende glir langs hver etappe med jevn fart,
    // som båt over vann, og hvert stopp tones inn når den reisende kommer fram.
    const bt = st.stat ? 1e9 : (st.started ? st.bt : -1);
    const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
    const legs = [], boatsRaw = [], stopT = [], pts = [];
    let tl0 = 1.1, trv = null;
    segs.forEach((s, j) => {
      pts.push(s.a, s.b);
      let c = s.c;
      if (!c) {
        const mx = (s.a[0] + s.b[0]) / 2, my = (s.a[1] + s.b[1]) / 2, dx = s.b[0] - s.a[0], dy = s.b[1] - s.a[1], len = Math.sqrt(dx * dx + dy * dy) || 1, kk = 0.2 * len * (j % 2 ? 1 : -1);
        c = [+(mx - dy / len * kk).toFixed(1), +(my + dx / len * kk).toFixed(1)];
      }
      const d = 'M' + s.a[0] + ' ' + s.a[1] + 'Q' + c[0] + ' ' + c[1] + ' ' + s.b[0] + ' ' + s.b[1];
      const L = Math.hypot(c[0] - s.a[0], c[1] - s.a[1]) + Math.hypot(s.b[0] - c[0], s.b[1] - c[1]);
      const dur = 0.45 + L / 300;
      const p = ease(Math.max(0, Math.min(1, (bt - tl0) / dur)));
      legs.push({ i: j, d, cls: 'leg ' + s.type, o: (100 * (1 - p)).toFixed(2) });
      const isBoat = !!s.c && (s.type === 'sea' || s.type === 'opt');
      if (p > 0 && p < 1) {
        const w = 1 - p;
        trv = { x: w * w * s.a[0] + 2 * w * p * c[0] + p * p * s.b[0], y: w * w * s.a[1] + 2 * w * p * c[1] + p * p * s.b[1], boat: isBoat };
      }
      if (isBoat) {
        const mx = 0.25 * s.a[0] + 0.5 * c[0] + 0.25 * s.b[0], my = 0.25 * s.a[1] + 0.5 * c[1] + 0.25 * s.b[1];
        const same = boatsRaw.find((o) => Math.hypot(o.x - mx, o.y - my) < 30);
        const done = bt >= tl0 + dur;
        if (!same) boatsRaw.push({ x: mx, y: my, opt: s.type === 'opt', on: done });
      }
      tl0 += dur + (s.stop !== undefined ? 0.35 : 0.05);
      if (s.stop !== undefined) stopT[s.stop] = tl0 - 0.35;
    });
    this._bEnd = tl0 + 0.6;
    const stops = mp.s.map((s, i) => ({
      n: i + 1, nm: s.nm, d: s.d, x: (P[s.k][0] / 10).toFixed(2), y: (P[s.k][1] / 4.7).toFixed(2), dly: '0s',
      cls: D.SIDE[s.k] + (s.o ? ' opt' : '') + (st.hl === i ? ' hl' : '') + (bt >= (stopT[i] || 0) ? ' on' : '')
    }));
    const rline = mp.s.map((s) => s.nm).join('  →  ') + '  ·  ' + mp.n + ' netter';
    const xs = pts.map((p) => p[0]), ys = pts.map((p) => p[1]);
    const bx0 = Math.min(...xs) - 150, bx1 = Math.max(...xs) + 150, by0 = Math.min(...ys) - 85, by1 = Math.max(...ys) + 85;
    const bs = Math.max(1, Math.min(1.7, 1000 / (bx1 - bx0), 470 / (by1 - by0)));
    let btx = 500 - ((bx0 + bx1) / 2) * bs, bty = 235 - ((by0 + by1) / 2) * bs;
    btx = Math.min(0, Math.max(1000 - 1000 * bs, btx)); bty = Math.min(0, Math.max(470 - 470 * bs, bty));
    const bCam = 'translate(' + (btx / 10).toFixed(3) + '%, ' + (bty / 4.7).toFixed(3) + '%) scale(' + bs.toFixed(4) + ')';
    const used = mp.s.filter((s, i) => bt >= (stopT[i] || 0)).map((s) => ' u-' + s.k).join('');
    const bmCls = 'bm' + (st.started || st.stat ? ' mapin f' + (st.gen % 2) : '') + used;
    const rv = sh.rv;
    const pk = {
      key: st.shown, scene: D.SC[st.shown], tag: sh.tag, ta: sh.ta, tb: sh.tb, desc: sh.desc, n: sh.n, a: sh.a, price: D.kr(sh.price), forWho: sh.forWho,
      ch: sh.ch, inc: sh.inc, hasRv: !!rv, rvq: rv ? rv.q : '', rvw: rv ? rv.w : '', rvx: rv ? rv.x : '',
      steps: sh.s.map((s, i) => ({
        n: i + 1, d: s.d, nm: s.nm, t: s.t, note: (D.NOTES[st.shown] || [])[i] || '', cls: (s.o ? 'it-opt' : '') + (st.hl === i && st.shown === st.pkg ? ' hl' : ''),
        enter: () => this.setState({ hl: i }), leave: () => this.setState({ hl: -1 })
      }))
    };
    return {
      rootCls: st.stat ? 'is-static' : '', prog: st.prog.toFixed(3), floatCls: st.fl && !st.flClosed ? 'show' : '',
      closeFloat: () => this.setState({ flClosed: true }),
      full: !this.props.bare,
      camTf, bCam, bS: bs.toFixed(4), sum,
      boats: boatsRaw.map((b) => ({ cls: 'boat' + (b.opt ? ' opt' : '') + (b.on ? ' on' : ''), dly: '0s', tf: 'translate(' + b.x.toFixed(1) + ' ' + b.y.toFixed(1) + ') scale(' + (1 / bs).toFixed(4) + ')' })),
      trv: {
        tf: 'translate(' + (trv ? trv.x : P.dps[0]).toFixed(1) + ' ' + (trv ? trv.y : P.dps[1]).toFixed(1) + ') scale(' + (1 / bs).toFixed(4) + ')',
        op: trv ? '1' : '0', dot: trv && !trv.boat ? '1' : '0', boat: trv && trv.boat ? '1' : '0'
      },
      rline,
      mapCls, routes, passes, tabs, bmCls, legs, stops, pk, swapCls: st.swap ? 'swap' : ''
    };
  }
}

class RSIMedReisen extends RSIMedReisenBase {
  renderVals() {
    const v = super.renderVals(), L = window.RSI_MR || {}, k = v.pk && v.pk.key, p0 = (L.pk || {})[k] || {}, hk = (window.RSI_K || {})['Pakkereise-' + k] || p0.handle, rp = (window.RSI_P || {})[hk] || (window.RSI_P || {})[p0.handle] || {}, p = { handle: hk, url: rp.url || (window.RSI_LINKS || {})['Pakkereise-' + k] || p0.url, img: rp.img || '', alt: rp.alt || '' };
    if (v.pk) { v.pk.tilpass = p.url || '#'; v.pk.req = (L.kontakt || '/pages/send-reiseforesporsel') + '?reise=' + (p.handle || k); v.pk.img = p.img || ''; v.pk.alt = p.alt || v.pk.name || ''; }
    return v;
  }
}
window.RSIMedReisen = RSIMedReisen;
